import { FleekError } from './FleekError';

type InvalidCidErrorOptions = {
  name: string;
};

export class InvalidCidError extends FleekError<InvalidCidErrorOptions> {
  public name = 'InvalidCidError';

  toString = () => `The cid ${this.data.name} is invalid.`;
}
